/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const frontmatter = undefined;
import {Code} from '../../../../components/utils/code';
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    a: "a",
    h2: "h2"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "WebSemaphore via HTTP/REST"
    }), "\n", _jsxs(_components.p, {
      children: ["HTTP is appropriate for serverless and server-based applications. It would seem that it works everywhere but\nif you are behind a firewall or have another network limitation, you might want to check ", _jsx(_components.a, {
        href: "./websockets",
        children: "websockets usage"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      children: "Sample repo"
    }), "\n", _jsxs(_components.p, {
      children: ["A reference implementation is available at\n", _jsx(_components.a, {
        href: "https://github.com/broadmindcloud/websemaphore-examples/tree/main/http-express",
        children: "WebSemaphore examples"
      }), " on github."]
    }), "\n", _jsx(_components.h2, {
      children: "HTTP Client"
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.a, {
        href: "https://www.websemaphore.com/docs/v1/api/rest",
        children: "REST section"
      }), "\nof the API guide describes the low-level operations that can be used\ndirectly using any HTTP client."]
    }), "\n", _jsx(Code, {
      language: "typescript",
      theme: "vs-dark",
      height: "500px",
      value: `import { WebSemaphoreHttpClientManager } from "websemaphore";
import fetch from "node-fetch";

const websemaphoreManager = WebSemaphoreHttpClientManager();

const websemaphoreClient = websemaphoreManager.initialize({ fetch, token: APIKEY });


const initHandler = (...) => {
    // ...
    const resp = await websemaphoreClient.semaphore.acquire(SEMAPHORE_ID, msg as any);
    // ...
}

const processingHandler = (...) => {
    // ...
    // do work
    // ...
    const resp = await websemaphoreClient.semaphore.release(SEMAPHORE_ID, { channelId: "default" });
    // ...
}`
    }), "\n", _jsx(_components.h2, {
      children: "Raw HTTP"
    }), "\n", _jsxs(_components.p, {
      children: ["You may use the ", _jsx(_components.a, {
        href: "",
        children: "OpenAPI spec"
      }), " to make direct requests to the WebSemaphore API. It may be used by any number\nof code generators and integration tools. Feel free to ", _jsx(_components.a, {
        href: "/contact",
        children: "contact us"
      }), " if you need support for your stack/language."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
